import { Box, Typography } from '@mui/material';

import SectionTitle from './SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '病患因心臟驟停、呼吸衰竭、上呼吸道阻塞等緊急情況需要氣管插管，以確保並維持呼吸道通暢、防止胃內容物吸入、幫助清除呼吸道分泌物，並在必要時進行機械式通氣：依據相關條件執行。',
  '視情況可能在施打鎮靜劑或肌肉鬆弛劑後，讓病患平躺於床上，使用喉頭鏡經口進入，將會厭舉起，然後將塑膠導管穿過聲門插入氣管內。',
];

const ResultPurpose = (props: Props) => {
  const { disabled } = props;

  return (
    <>
      <SectionTitle title="1. 手術必要性" />
      <Box sx={{ width: '98%', margin: '48px auto 24px auto' }}>
        {contents.map((v, i) => (
          <Typography
            sx={{
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '24px',
              whiteSpace: 'pre-wrap',
              marginBottom: '20px',
            }}
          >
            {v}
          </Typography>
        ))}
      </Box>
    </>
  );
};

export default ResultPurpose;
